import { render, staticRenderFns } from "./CreatorItem.vue?vue&type=template&id=36c8ddac&scoped=true&"
import script from "./CreatorItem.vue?vue&type=script&lang=js&"
export * from "./CreatorItem.vue?vue&type=script&lang=js&"
import style0 from "./CreatorItem.vue?vue&type=style&index=0&id=36c8ddac&scoped=true&lang=scss&"
import style1 from "./CreatorItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c8ddac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VTooltip})
